import axios from "@/axios.js";
import CoreFields from "./core_fields_service";

export default {
  getAllCoreFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      CoreFields.getAllCoreFields(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchFields(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/core_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeCoreField(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/fields/core_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingFieldLists(context, field_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/core_fields/get_existing_field_lists/${field_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingFieldLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/core_fields/search_existing_field_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/core_fields/update_core_field", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/core_fields/add_fields", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeFields({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/fields/core_fields/${roleId}`)
        .then(response => {
          commit("REMOVE_STEPS", roleId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
